import { getUrqlClient } from 'network/client';

import type { AnyVariables, DocumentInput } from 'urql';

/**
 * Imperative (non-hook) GraphQL query/mutation execution via the URQL client.
 * Use where React hooks can't — the shared client handles auth + error exchanges.
 *
 * Defaults to `network-only` so these one-shot fetches don't resolve against
 * the normalized graphcache (which would return stale data for callers that
 * need a fresh server read, e.g. refreshing a booking after order completion).
 */
export async function urqlFetch<T = unknown>(document: DocumentInput<T, AnyVariables>, variables: AnyVariables = {}) {
  const result = await getUrqlClient().query<T>(document, variables, { requestPolicy: 'network-only' }).toPromise();
  return result;
}
